import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class AdminUpdateUserAccountTypeArgs {
  @Field(t => Int)
  userId!: number

  // One of bsConstants.USER.ROLE_SELECTION. Only READER is currently supported.
  @Field(t => Int)
  accountType!: number
}
